import React, { useState } from "react";
import { Link } from "react-router-dom";
// import { BiShow } from "react-icons/bi";
// import { AiFillStar } from "react-icons/ai";
// import { FiShare2, FiBriefcase } from "react-icons/fi";
import { BiDotsVerticalRounded } from "react-icons/bi";
import DataTable from "react-data-table-component";
import {
  Button,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Pagination,
} from "reactstrap";
import ShareModal from "../../components/Modals/ShareModal";
import SelectRouteModal from "../../components/Modals/SelectRouteModal";
import CreateNewRouteModal from "../../components/Modals/CreateNewRouteModal";
import PointsListingModal from "../../components/Modals/PointsListingModal";
import ReportSuggestionModal from "../../components/Modals/ReportSuggestionModal";
import { routeDetail, updateRouteDetail } from "../../services/myRoute.service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { removeUserFavorite } from "../../services/favourites.service";
import "../../pages/Category/Cemetery/Cemetery.scss";
import UserNotLoggedIn from "../../components/UserNotLoggedIn/UserNotLoggedIn";
import marked_pop from "../../assets/marked_pop.svg";
import { IoHeartSharp, IoShareSocial } from "react-icons/io5";
import { categoryItems } from "../Home/Category";

const TableView = ({
  name,
  favourite,
  getFavouriteList,
  totalCount,
  pageSize,
  setPageSize,
  setCurrentPage,
  isUserLoggedIn,
  currentPage,
}) => {
  const [dropdownMenuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [routeName, setRouteName] = useState(null);
  const [route, setRoute] = useState(null);
  const [pointName, setPointName] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [mkmID, setMkmId] = useState();
  const [link, setLink] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);

  const userName = useSelector(
    (state) => state.userDetailReducer.userData.userName
  );

  const toggle = () => {
    setShowModal(!showModal);
    setRoute(null);
  };

  const createNewRoute = () => {
    setShowModal(false);
    setShowCreateRouteModal(true);
  };

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const addToRoute = (id) => {
    setMkmId(id);
    setShowModal(true);
  };

  const share = (id, poi) => {
    var data;
    if (Object.keys(id)[0] === "tzkim") {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-details/${id?.tzkim}/${poi}`;
      setLink(data);
    } else {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id?.mkm}/${poi}`;
      setLink(data);
    }
    setShowShareModal(true);
  };

  const removeFromFavorite = async (item) => {
    const willRemoveFavorite = await swal({
      title: "Are you sure?",
      text: "You want to remove this route from Favorites?",
      icon: marked_pop,
      buttons: true,
    });
    if (willRemoveFavorite) {
      try {
        const obj = {
          userName: userName,
        };
        const data = {
          mkmId: item?.mkmInfo ? item?.mkmInfo?.mkmID : null,
          tzId: item?.tzadikimInfo ? item?.tzadikimInfo?.tzadikimID : null,
        };
        const response = await removeUserFavorite(data, obj);
        if (response && response?.status === 200) {
          getFavouriteList();
          swal(
            "Removed!",
            "Your route has been removed from Favorites!",
            "success"
          );
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "Oops.. something went wrong, try again !!!",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    }
  };

  const selectRoute = async () => {
    let existingData;
    if (route?.id) {
      try {
        let response = await routeDetail({
          userName: userName,
          routeID: route?.id,
        });
        if (response && response?.status === 200) {
          existingData = response?.data?.data;
        }

        let requestBody = [];
        if (existingData?.length < 25) {
          if (existingData?.length === 0) {
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 0,
              visited: false,
            });
          } else if (existingData?.length === 1) {
            requestBody?.push({
              mkmID: existingData[0]?.place?.mkmID,
              orderNumber: 0,
              visited: false,
            });
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 1,
              visited: false,
            });
          } else {
            existingData?.splice(existingData?.length, 0, {
              mkmID: mkmID,
              orderNumber: existingData?.length,
              visited: false,
            });
            requestBody = existingData?.map((item, i) => {
              return {
                mkmID: item?.place?.mkmID || item?.mkmID,
                orderNumber: i,
                visited: item?.visited,
              };
            });
          }
          try {
            setShowSpinner(true);
            let res = await updateRouteDetail(requestBody, {
              userName: userName,
              routeID: route?.id,
            });
            if (res && res?.status === 200) {
              toast.success("Point Added Successfully In Your Route!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
              setShowSpinner(false);
            }
          } catch (err) {
            toast.error(
              err?.response?.data?.message ||
                "Oops.. something went wrong, try again !!!",
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              }
            );
            setShowSpinner(false);
          }
          setRoute("");
          setShowModal(false);
        } else {
          toast.warning(
            "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
          setShowSpinner(false);
        }
        setRoute("");
        setShowModal(false);
      } catch (error) {
        console.log(error);
        setShowSpinner(false);
      }
    }
    if (!route?.id) {
      toast.error("Please Select The Route.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      setShowSpinner(false);
    }
  };

  const handlePerRowsChange = async (newPageSize, pageSize) => {
    setPageSize(newPageSize);
  };

  const customStyles = {
    tableWrapper: {
      style: { overflowX: "auto" },
    },
    table: {
      style: {
        backgroundColor: "transparent",
        // minWidth: "1150px",
      },
    },
    headRow: {
      style: {
        height: "50px",
        borderRadius: "5px",
        borderWidth: "1px",
        border: "1px solid #81818133",
        background: "#F5F5F5",
        marginBottom: "16px",
      },
    },
    headCells: {
      style: {
        fontFamily: "Lato, sans-serif",
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0%",
        color: "#494949",
        textTransform: "none",
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    },
    rows: {
      style: {
        borderRadius: "3.75px",
        borderWidth: "0.7px",
        border: "0.7px solid #B1AFAD",
        borderBottom: "0.7px solid #B1AFAD !important",
        backgroundColor: "transparent",
        marginBottom: "16px",
      },
      stripedStyle: {
        backgroundColor: "transparent",
      },
      highlightOnHoverStyle: {
        backgroundColor: "rgba(0,0,0,0.05)",
        transitionDuration: "0.25s",
        borderRadius: "3.75px",
      },
      cells: {
        style: {
          backgroundColor: "transparent",
          paddingLeft: "0px",
          paddingRight: "0px",
        },
      },
    },
  };

  const columns = [
    {
      name: "Image",
      sortable: true,
      cell: (d) => (
        <img
          src={
            d?.mkmInfo
              ? categoryItems?.filter(
                  (item) => item?.title === d?.mkmInfo?.placeList
                )?.[0]?.icon || categoryItems?.[0]?.icon
              : categoryItems?.[0]?.icon
          }
          alt=""
          style={{
            height: "70px",
            width: "70px",
            marginBlock: "11px",
            borderRadius: "5px",
          }}
        />
      ),
      width: "13%",
      grow: 0,
      style: { paddingLeft: "12px", paddingRight: "12px", maxWidth: "13%" },
    },
    {
      name: "Place Name",
      selector: (row) => row?.mkmInfo?.title,
      sortable: true,
      cell: (d) =>
        d?.tzadikimInfo?.tzadikimID ? (
          <Link
            to={`/category-detail/?tzadikimId=${d?.tzadikimInfo?.tzadikimID}&cor=${d?.tzadikimInfo?.poi}`}
            state={{
              from: "favourite",
              categoryName: d?.tzadikimInfo?.tzadikimID && "Tzadikim",
              categoryTitle: d?.tzadikimInfo?.tzadikimID && "צדיקים",
            }}
          >
            <span className="link_route">
              {d?.mkmInfo?.title ? d?.mkmInfo?.title : d?.tzadikimInfo?.title}
            </span>
          </Link>
        ) : (
          <Link
            to={`/category-detail/?MkmId=${d?.mkmInfo?.mkmID}&cor=${d?.mkmInfo?.poi}`}
            state={{
              from: "favourite",
              categoryName: d?.tzadikimInfo?.tzadikimID && "Tzadikim",
              categoryTitle: d?.tzadikimInfo?.tzadikimID && "צדיקים",
            }}
          >
            <span className="link_route">
              {d?.mkmInfo?.title ? d?.mkmInfo?.title : d?.tzadikimInfo?.title}
            </span>
          </Link>
        ),
      width: "16.5%",
      grow: 0,
      style: {
        paddingLeft: "12px",
        paddingRight: "12px",
        maxWidth: "16.5%",
        fontWeight: 700,
      },
    },
    {
      name: "Location",
      selector: (row) => row?.mkmInfo?.cityE + " " + row?.mkmInfo?.stateE,
      sortable: true,
      width: "18%",
      grow: 0,
      cell: (d) => (
        <span className="link_route">
          {d?.mkmInfo
            ? d?.mkmInfo?.cityE + " " + d?.mkmInfo?.stateE
            : d?.tzadikimInfo?.cityE + " " + d?.tzadikimInfo?.stateE}
        </span>
      ),
      style: {
        paddingLeft: "12px",
        paddingRight: "12px",
        maxWidth: "18%",
        fontFamily: "Lato",
        fontSize: "16px",
        color: "#494949",
      },
    },
    {
      name: "Contact",
      selector: (row) => row?.contact,
      sortable: true,
      cell: (d) => (
        <span
          className="link_route"
          style={{ fontSize: "16px", color: "#494949" }}
        >
          N/A
        </span>
      ),

      width: "12%",
      grow: 0,
      style: { paddingLeft: "12px", paddingRight: "12px", maxWidth: "12%" },
    },
    {
      name: "Add to Route",
      selector: (row) => row?.add_route,
      sortable: true,
      cell: (d) => {
        return (
          <div
            className="btn_add_to_route"
            type="button"
            onClick={() =>
              addToRoute(
                d?.tzadikimInfo?.tzadikimID
                  ? d?.tzadikimInfo?.tzadikimID
                  : d?.mkmInfo?.mkmID
              )
            }
          >
            Add to Route
          </div>
        );
      },
      width: "20%",
      grow: 0,
      style: { paddingLeft: "12px", paddingRight: "12px", maxWidth: "20%" },
    },
    {
      name: "Actions",
      selector: (row) => row?.mkmInfo?.mkmID,
      sortable: true,
      cell: (d, index) => {
        return (
          <div className="actions">
            <div className="favourite_icon" onClick={() =>
                removeFromFavorite(
                d?.tzadikimID
                    ? { tzadikimID: d?.tzadikimID }
                    : { mkmID: d?.mkmID },
                d?.userFavorite
                )
            }>
              <IoHeartSharp size="22px" color="#F57D2B" />
            </div>
            <Button
              className="link_share"
              onClick={() =>
                share(
                  d?.tzadikimInfo?.tzadikimID
                    ? { tzkim: d?.tzadikimInfo?.tzadikimID }
                    : { mkm: d?.mkmInfo?.mkmID },
                  d?.tzadikimInfo?.poi ? d?.tzadikimInfo?.poi : d?.mkmInfo?.poi
                )
              }
            >
              <IoShareSocial size="22px" />
            </Button>
            {d?.tzadikimInfo?.tzadikimID ? (
              <Button className="link_view_more">
                <Link
                  to={`/category-detail/?tzadikimId=${d?.tzadikimInfo?.tzadikimID}&cor=${d?.tzadikimInfo?.poi}`}
                  state={{
                    from: "favourite",
                    categoryName: d?.tzadikimInfo?.tzadikimID && "Tzadikim",
                    categoryTitle: d?.tzadikimInfo?.tzadikimID && "צדיקים",
                  }}
                >
                  view more
                </Link>
              </Button>
            ) : (
              <Button className="link_view_more">
                <Link
                  to={`/category-detail/MkmId=${d?.mkmInfo?.mkmID}&cor=${d?.mkmInfo?.poi}`}
                  state={{
                    from: "favourite",
                    categoryName: d?.tzadikimInfo?.tzadikimID && "Tzadikim",
                    categoryTitle: d?.tzadikimInfo?.tzadikimID && "צדיקים",
                  }}
                >
                  view more
                </Link>
              </Button>
            )}
            <Dropdown
              className="moreInfo"
              toggle={() =>
                setMenuOpen(index === dropdownMenuOpen ? null : index)
              }
              isOpen={index === dropdownMenuOpen}
            >
              <DropdownToggle
                className="link_dots"
                style={{ padding: "0px", height: "45px", width: "45px" }}
              >
                <BiDotsVerticalRounded size="22px" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <Link
                    to={`/along-the-way-to-here/${
                      d?.tzadikimInfo?.poi
                        ? d?.tzadikimInfo?.poi
                        : d?.mkmInfo?.poi
                    }`}
                    state={{ from: "favourite" }}
                    className="breadcrumb_item1"
                  >
                    Along the way to here
                  </Link>
                </DropdownItem>
                <DropdownItem
                  onClick={() =>
                    reportSuggestion(
                      d?.tzadikimInfo?.title
                        ? d?.tzadikimInfo?.title
                        : d?.mkmInfo?.title,
                      d?.tzadikimInfo?.tzadikimID
                        ? { tzkim: d?.tzadikimInfo?.tzadikimID }
                        : { mkm: d?.mkmInfo?.mkmID }
                    )
                  }
                >
                  Report suggestion
                </DropdownItem>
                {/* <DropdownItem onClick={() => removeFromFavorite(d)}>
                  Remove from favourites
                </DropdownItem> */}
              </DropdownMenu>
            </Dropdown>
          </div>
        );
      },
      width: "16%",
      grow: 0,
      style: { paddingLeft: "12px", paddingRight: "12px", maxWidth: "16%" },
    },
  ];

  return (
    <div className="table_view" style={{ marginBottom: "80px" }}>
      <SelectRouteModal
        route={route}
        setRoute={setRoute}
        showModal={showModal}
        toggle={toggle}
        createNewRoute={createNewRoute}
        selectRoute={selectRoute}
        showSpinner={showSpinner}
      />
      <CreateNewRouteModal
        showCreateRouteModal={showCreateRouteModal}
        setShowCreateRouteModal={setShowCreateRouteModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        routeName={routeName}
        setRouteName={setRouteName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <PointsListingModal
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <ReportSuggestionModal
        showReportModal={showReportModal}
        setShowReportModal={setShowReportModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        mkmID={mkmID}
      />
      <ShareModal
        showShareModal={showShareModal}
        setShowShareModal={setShowShareModal}
        link={link}
        setLink={setLink}
      />
      {isUserLoggedIn ? (
        <>
          <DataTable
            columns={columns}
            data={favourite}
            customStyles={customStyles}
            //   pagination
            //   paginationServer
            //   paginationTotalRows={totalCount}
            //   paginationPerPage={pageSize}
            //   paginationRowsPerPageOptions={[10, 20, 50, 100]}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={(currentPage) => setCurrentPage(currentPage)}
            style={{overflow: "unset"}}
          />
        </>
      ) : (
        <UserNotLoggedIn />
      )}
      <div style={{ marginTop: "-16px" }}>
        {console.log("jwekbfe", totalCount, currentPage)}
        {(totalCount ?? 0) > 0 && (
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={totalCount}
            pageSize={pageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}
      </div>
    </div>
  );
};

export default TableView;
